module.exports = __webpack_public_path__ + "img/DS224+.e67f5db5.png";